import { type z } from 'zod'

import { schemas } from '~interface/zod-schema'

// Values
export const AIInteractionType = schemas.AIInteractionTypeEnum
export const AgentTool = schemas.AgentToolEnum
export const AIPhoneLineType = schemas.AIPhoneLineTypeEnum
export const InteractionCategoryType = schemas.InteractionCategoryTypeEnum
export const InteractionRatingType = schemas.InteractionRatingTypeEnum
export const UserSentiment = schemas.UserSentimentEnum
export const ResponseOutcome = schemas.ResponseOutcomeEnum
export const AccessReason = schemas.AccessReasonEnum
export const SourceAccessTypeEnum = schemas.SourceAccessTypeEnum
export const ToolCallStatus = schemas.ToolCallStatusEnum
export const SearchLayoutType = schemas.SearchLayoutTypeEnum

// Types
export type AgenticImplementationAttachment = z.infer<
  typeof schemas.AgenticImplementationAttachmentSerializerAgenticImplementationAttachment
>
export type AgenticImplementationMessage = z.infer<
  typeof schemas.AgenticImplementationMessageSerializerAgenticImplementationMessage
>
export type AIInteractionTypeEnum = z.infer<typeof schemas.AIInteractionTypeEnum>
export type AgentToolEnum = z.infer<typeof schemas.AgentToolEnum>
export type AccessReasonEnum = z.infer<typeof schemas.AccessReasonEnum>
export type EnrichedToolCall = z.infer<typeof schemas.EnrichedToolCall>
export type AppliedUsagePolicies = z.infer<typeof schemas.AppliedUsagePolicies>
export type InteractionCategoryTypeEnum = z.infer<typeof schemas.InteractionCategoryTypeEnum>
export type InteractionRatingTypeEnum = z.infer<typeof schemas.InteractionRatingTypeEnum>
export type ResponseOutcomeEnum = z.infer<typeof schemas.ResponseOutcomeEnum>
export type UserSentimentEnum = z.infer<typeof schemas.UserSentimentEnum>
export type WebsiteTypeEnum = z.infer<typeof schemas.WebsiteTypeEnum>
export type AIPhoneLine = z.infer<typeof schemas.AIPhoneLine>
export type TwilioAccountConfig = z.infer<typeof schemas.TwilioAccountConfig>
export type AISkill = z.infer<typeof schemas.AISkill>
export type AIEmail = z.infer<typeof schemas.AIEmail>
export type EnrichedAIPhoneLineConfig = z.infer<typeof schemas.EnrichedAIPhoneLineConfig>
export type AIInteractionFilter = z.infer<typeof schemas.AIInteractionFilter>
export type AIPhoneLineTypeEnum = z.infer<typeof schemas.AIPhoneLineTypeEnum>
export type AIPhoneLineOwnerEnum = z.infer<typeof schemas.AIPhoneLineOwnerEnum>
export type AIProcessSource = z.infer<typeof schemas.AIProcessSource>
export type AITestResponseInfo = z.infer<typeof schemas.AITestResponseInfo>
export type AITestScenarioInfo = z.infer<typeof schemas.AITestScenarioInfo>
export type AITestQueryInfo = z.infer<typeof schemas.AITestQueryInfo>
export type AITestRun = z.infer<typeof schemas.AITestRun>
export type AITestRunWithStats = z.infer<typeof schemas.AITestRunWithStats>
export type EvaluationMetricResult = z.infer<typeof schemas.EvaluationMetricResult>
export type AIChatSizeEnum = z.infer<typeof schemas.AIChatSizeEnum>
export type CrawlTask = z.infer<typeof schemas.CrawlTask>
export type CrawlTaskDashboardData = z.infer<typeof schemas.GetCrawlTaskDashboardViewResponseData>
export type EnrichedPageSource = z.infer<typeof schemas.EnrichedPageSource>
export type EnrichedChunk = z.infer<typeof schemas.EnrichedChunk>
export type LightweightQuerySourcesLog = z.infer<typeof schemas.LightweightQuerySourcesLog>
export type ELVoice = z.infer<typeof schemas.ELVoice>
export type PreviewVoiceRequest = z.infer<typeof schemas.PreviewVoiceRequest>
export type EnrichedOrganizationAISettings = z.infer<typeof schemas.EnrichedOrganizationAISettings>
export type FAQSource = z.infer<typeof schemas.FAQSource>
export type Folder = z.infer<typeof schemas.Folder>
export type KnowledgeBaseItemSummary = z.infer<typeof schemas.KnowledgeBaseItemSummary>
export type DomainSitemapNode = z.infer<typeof schemas.DomainSitemapNode>
export type KnowledgeBaseItemType = z.infer<typeof schemas.KnowledgeBaseItemTypeEnum>
export type GISLayer = z.infer<typeof schemas.EnrichedGISLayerSource>
export type PageSourceSummary = z.infer<typeof schemas.PageSourceSummary>
export type PhonicVoice = z.infer<typeof schemas.PhonicVoice>
export type PhonicPronunciationDictionaryEntry = z.infer<
  typeof schemas.PhonicPronunciationDictionaryEntry
>
export type PhonicBackgroundNoise = z.infer<typeof schemas.PhonicBackgroundNoiseEnum>
export type PhonicIntelligenceLevel = z.infer<typeof schemas.PhonicIntelligenceLevelEnum>
export type PhonicMultilingualMode = z.infer<typeof schemas.PhonicMultilingualModeEnum>
export type PageEdit = z.infer<typeof schemas.EditPageSourceViewRequestData>
export type QuerySourcesLog = z.infer<typeof schemas.QuerySourcesLog>
export type SourceAccessType = z.infer<typeof schemas.SourceAccessTypeEnum>
export type SearchLayoutTypeEnum = z.infer<typeof schemas.SearchLayoutTypeEnum>
export type TransferLineSource = z.infer<typeof schemas.TransferLineSource>
export type TransferLineSourceConfig = z.infer<typeof schemas.TransferLineSourceConfig>
export type ToolCallSummary = z.infer<typeof schemas.ToolCallSummary>
export type ToolCallStatusEnum = z.infer<typeof schemas.ToolCallStatusEnum>
export type ToolCallDashboardStats = z.infer<typeof schemas.ToolCallDashboardStats>
export type ToolCallBucket = z.infer<typeof schemas.ToolCallBucket>
export type SearchSuggestion = z.infer<typeof schemas.SearchSuggestion>
export type WebsiteType = z.infer<typeof schemas.WebsiteTypeEnum>
export type CrawlStatus = z.infer<typeof schemas.CrawlStatusEnum>
export type FirecrawlConcurrencyData = z.infer<
  typeof schemas.GetFirecrawlConcurrencyViewResponseData
>
export type FirecrawlConcurrencyLog = z.infer<typeof schemas.FirecrawlConcurrencyLog>
export type Sentiment = z.infer<typeof schemas.UserSentimentEnum>
export type InteractionBucket = z.infer<typeof schemas.InteractionBucket>
export type InteractionDashboardStats = z.infer<typeof schemas.InteractionDashboardStats>
export type LLMCostBucket = z.infer<typeof schemas.LLMCostBucket>
export type LLMCostDashboardStats = z.infer<typeof schemas.LLMCostDashboardStats>
export type GetLLMCostDashboardStatsResponse = z.infer<
  typeof schemas.GetLLMCostDashboardStatsViewResponseData
>
export type HealthCheckOutcomeEnum = z.infer<typeof schemas.HealthCheckOutcomeEnum>

export type ActiveCall = z.infer<typeof schemas.ActiveCall>
export type WarmHandoffData = z.infer<typeof schemas.WarmHandoffData>
